module.exports = __webpack_public_path__ + "img/chr_ts_90_23.444d4c5f.png";